import { cn } from "@/lib/utils";

// Progress bar. variant "signature" = mint->blue->purple gradient, "blue" = flat blue.
export function ScoreBar({ value = 0, variant = "signature", className = "", height = "h-2" }) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={cn("w-full overflow-hidden rounded-full bg-white/8", height, className)}>
      <div
        className={cn(
          "h-full rounded-full transition-all duration-700",
          variant === "signature" ? "bloq-gradient" : "bg-bloq-blue",
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
